module.exports = __webpack_public_path__ + "static/media/small_girl.02238741.svg";